const EPSILON = 0.0001;

export function floatEqual(a, b) {
  return Math.abs(b - a) < EPSILON;
}

export function floatLessThanOrEqual(small, big) {
  return small - big < EPSILON || floatEqual(small, big);
}

export function floatLessThan(small, big) {
  return floatLessThanOrEqual(small, big) && !floatEqual(small, big);
}

export function floatGreaterThanOrEqual(small, big) {
  return small - big > EPSILON || floatEqual(small, big);
}

export function floatGreaterThan(small, big) {
  return floatGreaterThanOrEqual(small, big) && !floatEqual(small, big);
}
